import React, { FC } from 'react';

import styles from './roomstay-blog-customer-case-image.module.scss';
import ClippedBox, { POSITION } from '../roomstay-blog-image-block/clipped-box';
import classNames from 'classnames';
import { useElementSize, useWindowSize } from 'usehooks-ts';
import { LazyLoadImage } from '../lazy-load-image';

export type CustomerCaseImageProps = {
    theme: 'default' | 'type-2';
    image: string;
    backgroundTop: string;
    backgroundBottom: string;
};

const RoomStayBlogCustomerCaseImage: FC<CustomerCaseImageProps> = (props) => {
    const { theme, image, backgroundBottom, backgroundTop } = props;
    const [containerRef, { height }] = useElementSize();
    const [introRef, { height: introHeight }] = useElementSize();
    const { width: windowWidth } = useWindowSize();

    const isTablet = windowWidth <= 991;

    return (
        <div ref={containerRef} className={classNames(styles.container, theme === 'type-2' && styles.type2)}>
            {theme === 'type-2' ? (<>
                <ClippedBox
                    customPolygon="0% 100%, 100% 100%, 100% 0%, 100% 0%"
                    configs={[]}
                    className={classNames(styles.background, styles.backgroundClipTop)}
                    style={{
                        backgroundColor: `${backgroundTop || '#f9f9fa'}`,
                        maxHeight: isTablet ? 48 : 100,
                        transform: 'rotate(180deg)',
                    }}
                />
                <ClippedBox
                    customPolygon="0% 0%, 0% 100%, 101% 0%, 0% 0%"
                    configs={[]}
                    className={classNames(styles.background, styles.backgroundClipBottom)}
                    style={{
                        backgroundColor: `${backgroundBottom || '#1C1624'}`,
                        maxHeight: isTablet ? 48 : 100,
                        transform: 'rotate(180deg)',
                        marginTop: '0px',
                    }}
                />
            </>) : (<>
                <ClippedBox
                    configs={[
                        {
                            rad: Math.atan(81 / 1920),
                            position: POSITION.TopLeft,
                        },
                    ]}
                    className={styles.background}
                    style={{
                        backgroundColor: `${backgroundTop}`,
                        maxHeight: `${windowWidth > 768 ? introHeight + 120 : introHeight + 40}px`,
                        transform: 'rotate(180deg)',
                    }}
                />
                <ClippedBox
                    configs={[
                        {
                            rad: Math.atan(81 / 1920),
                            position: POSITION.BottomRight,
                        },
                    ]}
                    className={styles.backgroundBottom}
                    style={{
                        backgroundColor: '#fff',
                        maxHeight: `${windowWidth > 768 ? introHeight + 70 : introHeight + 40}px`,
                        transform: 'rotate(180deg)',
                        marginTop: '0px',
                    }}
                />
            </>)}
            
            <LazyLoadImage className={styles.wrapperImg} imageUrl={image} objectFit="cover" />
        </div>
    );
};

export default RoomStayBlogCustomerCaseImage;
